@use '../../styling/badges.scss' as *;
@use '../../styling/colors.scss' as *;

.SutStatusBadge {
  @extend %badge-base;
}

.SutStatusBadgeDisabled {
  background: $color-highlight-red;
}

.SutStatusBadgeLocked {
  background: $color-highlight-yellow;
}

.SutStatusBadgeAvailable {
  background: $color-highlight-green;
}
